import { useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { getSite } from '../lib/site';

const links = [
  { to: '/about', label: 'About' },
  { to: '/lessons', label: 'Lessons' },
  { to: '/classes', label: 'Classes' },
  { to: '/camp', label: 'Camp' },
  { to: '/stories', label: 'Stories' },
  { to: '/studio', label: 'Studio' },
  { to: '/contact', label: 'Contact' },
];

export function Layout() {
  const site = getSite();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const overHero = pathname === '/';

  return (
    <>
      <header className={`site-header${overHero ? ' site-header--hero' : ''}`}>
        <div className="wrap nav-inner">
          <Link to="/" className="brand" onClick={() => setOpen(false)}>
            Miss <span className="brand-accent">Natalie</span>
          </Link>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            Menu
          </button>
          <nav className={`nav-links${open ? ' open' : ''}`} aria-label="Primary">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="nav-cta" onClick={() => setOpen(false)}>
              Book a lesson
            </Link>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="wrap footer-inner">
          <div>
            <strong className="display footer-brand">{site.name}</strong>
            <p className="footer-blurb">{site.footer.blurb}</p>
          </div>
          <div className="footer-meta">
            <p>{site.location.primary}</p>
            <p>{site.location.secondary}</p>
            <p className="footer-links">
              <Link to="/lessons">Lessons</Link>
              {' · '}
              <Link to="/stories">Stories</Link>
              {' · '}
              <Link to="/classes">Classes</Link>
              {' · '}
              <Link to="/contact">Contact</Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
